import { useCallback } from 'react';

import { HorizontalContainer, VerticalContainer } from '@american-autonomy/ag-ui';

import Link from 'components/Link';
import SecondaryButton from 'components/buttons/SecondaryButton';
import HeroTitleText from 'components/text/HeroTitleText';
import ParagraphText from 'components/text/ParagraphText';

import useLogout from 'hooks/useLogout';

import useSendEmail from './hooks/useSendEmail';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const VerifyEmailPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { sendEmail } = useSendEmail();
    const { logout } = useLogout();
    const { ACTIVATION_LINK_SENT, BACK_TO_LOGIN, DID_NOT_GET_LINK, SEND_AGAIN, TITLE } =
        useTranslation();

    const resendVerificationEmail = useCallback(async () => {
        await sendEmail();
    }, [sendEmail]);

    return (
        <VerticalContainer className={styles.verifyEmailPage} testId={testId}>
            <HeroTitleText text={TITLE} />

            <ParagraphText text={ACTIVATION_LINK_SENT} />

            <VerticalContainer>
                <ParagraphText text={DID_NOT_GET_LINK} />

                <HorizontalContainer className={styles.horizontalContainer}>
                    <SecondaryButton onClick={resendVerificationEmail} text={SEND_AGAIN} />
                </HorizontalContainer>

                <Link onClick={logout} text={BACK_TO_LOGIN} to={''} />
            </VerticalContainer>
        </VerticalContainer>
    );
};

export default VerifyEmailPage;
